export default "__VITE_ASSET__CSsd$Dgl__"